import { styleToClassName } from './styleToClassName';
import { extractStyleParts } from './extractStyleParts';
/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */

export function mergeStyles() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = extractStyleParts(args),
      classes = _a.classes,
      objects = _a.objects;

  if (objects.length) {
    classes.push(styleToClassName(objects));
  }

  return classes.join(' ');
}